import Const from '@/helper/const'
import { custAxios } from './genericApi'

export default {
  getAllExtracts (params) {
    const { idClient } = params

    delete params.idClient

    return custAxios().get(`${Const.API_LOGS}/${idClient}`, {
      params
    })
  }
}
